import { type FormTemplate } from '@wix/ambassador-forms-v1-form-template/types';
import {
  type Form,
  type FormField,
  type ItemLayout,
  type Step,
} from '@wix/ambassador-forms-v4-form/types';

export const addFieldToSchema = (
  form: Form | FormTemplate,
  field: FormField,
  layout: ItemLayout,
) => {
  const newSteps: Step[] | undefined = form.steps?.map((step) => {
    return {
      ...step,
      layout: {
        ...step.layout,
        large: {
          ...(step.layout?.large || {}),
          items:
            step.layout?.large?.items?.map((item) => {
              return {
                ...item,
                row: layout.row! <= item.row! ? (item.row || 0) + 1 : item.row,
              };
            }) || step.layout?.large?.items,
        },
      },
    };
  });
  newSteps?.[0].layout?.large?.items?.unshift(layout);

  return {
    ...form,
    fields: [field, ...(form.fields || [])],
    steps: newSteps || form.steps,
  };
};
